export default "__VITE_ASSET__ad794c2b__"